/**
 * An event message.
 *
 * @property {Object} [params] - Map of key value pairs with the parameter name as the key (string) and the parameter
 *                               value as the value (string)
 * @property {string} [text]   - Message text
 * @property {string} [type]   - Message type
 */
export class EventMessage {
    constructor() {
        this.params = null
        this.text = null
        this.type = null
    }
}
